import { useQuery } from "react-query";

import { autoChecklistService } from "services";
import { OwnerType } from "types";

const useExperianOwnerResultQuery = ({
	id,
	ownerType,
}: {
	id: number;
	ownerType: OwnerType;
}) =>
	useQuery(
		["experianOwnerResult", id, ownerType],
		() => autoChecklistService.getExperian(id, ownerType),
		{
			initialData: {
				aurora_outcome: "fail",
				result_mode: "manually_set",
			},
			retry: 0,
			cacheTime: 0,
			enabled: !!id && !!ownerType,
		},
	);

export default useExperianOwnerResultQuery;
